import { DatagridWithFooterStyled } from './DatagridWithFooter.styled';

export const DatagridWithFooter = DatagridWithFooterStyled;
